import React from 'react';
import { Link } from 'react-router-dom';
import { extractPlainText } from '../../utils/richTextRenderer';

const SolutionHero = ({ solution }) => {
  if (!solution) {
    return null;
  }

  return (
    <section className="bg-gradient-to-br from-catalina-blue to-san-marino py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Breadcrumb */}
        <nav className="mb-8">
          <ol className="flex items-center space-x-2 text-sm text-white/80">
            <li>
              <Link to="/" className="hover:text-white transition duration-300">
                Home
              </Link>
            </li>
            <li>
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </li>
            <li>
              <Link to="/solutions-we-provide" className="hover:text-white transition duration-300">
                Solutions
              </Link>
            </li>
            <li>
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </li>
            <li className="text-white font-medium">
              {solution.Title}
            </li>
          </ol>
        </nav>

        {/* Hero Content */}
        <div className="text-white">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            {solution.Title}
          </h1>
          {solution.Description && (
            <p className="text-lg md:text-xl text-white/90 max-w-3xl leading-relaxed">
              {extractPlainText(solution.Description, 300)}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default SolutionHero;